<!--
  @Description 统计分析
  @Date 2021-12-22
  @Author liushuo
-->
<template>
  <div class="container">
    <homeHeader title="统计分析"></homeHeader>
    <div class="main"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: calc(100vh - @header-height);
  background-color: #f2f3f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
